import React from 'react';

const Tips = () => {
  return (
    <div className="container">
      <h2>Sustainability Tips</h2>
      <div className="tip">
        <h3>Tip 1: Reduce Plastic Waste</h3>
        <p>Use reusable bags and containers to reduce plastic waste.</p>
      </div>
      <div className="tip">
        <h3>Tip 2: Save Energy</h3>
        <p>Turn off lights and electronics when not in use to conserve energy.</p>
      </div>
      <div className="tip">
        <h3>Tip 3: Plant Trees</h3>
        <p>Plant trees and support reforestation efforts to combat climate change.</p>
      </div>
      <div className="tip">
        <h3>Tip 4: Conserve Water</h3>
        <p>Fix leaks and use water-saving appliances to conserve water resources.</p>
      </div>
      <div className="tip">
        <h3>Tip 5: Reduce Food Waste</h3>
        <p>Plan meals, store food properly, and compost waste to reduce food waste.</p>
      </div>
      {/* Add more tips */}
    </div>
  );
};

export default Tips;
